import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import Script from '../Script';
/**
 * Render a JavaScript snippet that loads Curalate.
 */

export default function CuralateSnippet(_ref) {
  var _ref$siteName = _ref.siteName,
      siteName = _ref$siteName === void 0 ? config.get('public.curalate.siteName') : _ref$siteName,
      _ref$skipServerRender = _ref.skipServerRender,
      skipServerRender = _ref$skipServerRender === void 0 ? true : _ref$skipServerRender;
  var siteNameString = encodeURIComponent(siteName);
  return /*#__PURE__*/React.createElement(Script, {
    skipServerRender: skipServerRender,
    globalScriptKey: ['curalate', siteName],
    dangerouslySetInnerHTML: {
      __html: "\n!function(){var e=window.crl8=window.crl8||{},n=!1,i=[];e.ready=function(e){\nn?e():i.push(e)},e.pixel=e.pixel||function(){e.pixel.q.push(arguments)},\ne.pixel.q=e.pixel.q||[];var t=window.document,o=t.createElement(\"script\"),\nc=e.debug||-1!==t.location.search.indexOf(\"crl8-debug=true\")?\"js\":\"min.js\";\no.src=t.location.protocol+\"//cdn.curalate.com/sites/".concat(siteNameString, "/site/latest/site.\"+c,\no.onload=function(){n=!0,i.forEach(function(e){e()})};var r=t.getElementsByTagName(\"script\")[0];\nr.parentNode.insertBefore(o,r.nextSibling)}();\n")
    }
  });
}
CuralateSnippet.propTypes = {
  /**
   * The site name to put in the Curalate script URL. If not provided, it will
   * attempt to use the `public.curalate.siteName` config option.
   */
  siteName: PropTypes.string,

  /**
   * Whether to skip server side rendering the script.
   */
  skipServerRender: PropTypes.bool
};